import styled, { keyframes } from "styled-components";
import spinnerSVG from "../../assets/spinner.svg";

const rotation = keyframes`
  100% { 
    -webkit-transform: rotate(360deg); 
    transform:rotate(360deg); 
  }
`;

export const SpinnerRaw = styled.img.attrs({
  src: spinnerSVG,
})`
  animation: ${rotation} 2s linear infinite;
  height: ${(props) => props.height}; /* Set default height if not provided */
  width: ${(props) => props.width}; /* Set default width if not provided */
`;

export const Spinner = ({ height, width }: any) => {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <SpinnerRaw height={height} width={width} />
    </div>
  );
};
